import moment from 'moment';

export default function DateFormatter() {
    this.iso = function(date) {
        return moment(date).format('YYYY-MM-DD');
    };

    this.datetime = function(date) {
        return moment(date).format('DD/MM/YYYY HH:mm');
    };

    this.id = function(date) {
        return moment(date).format('DD/MM/YYYY');
    };

    this.idTime = function(date) {
        return moment(date).format('HH:mm');
    };

    this.dTime = function() {
        return moment().startOf('day').format('HH:mm');
    };

    this.strToDate = function(date) {
        return moment(date).format('YYYY-MM-DD');
    }

    this.cTime = function(time) {
        var date = new Date(`1970-01-01T${time}`)

        return moment(date).format('HH-mm');
    };

    this.uTime = function(time) {
        var date = new Date(`1970-01-01T${time}`)

        return moment(date).format('HHmm');
    };

    this.nowDate = function() {
        var date = new Date()

        return moment(date).format('YYYY-MM-DD');
    };
}